import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="notifications"
export default class extends Controller {

  static targets = ["container"]
  connect() {
    // Listen for any Turbo Stream inserting notifications
    document.addEventListener("turbo:before-stream-render", (event) => {
      const target = event.target.getAttribute("target")

      if (target === "notifications") {
        this.playSound()
      }
    })
  }

  playSound() {
    const audio = new Audio("/assets/notification.mp3")
    audio.volume = 0.2 // soft, not annoying
    audio.play().catch(() => {
      console.log("Audio blocked by browser (needs user interaction)")
    })
  }

  showToast(html) {
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    const toastEl = this.containerTarget.lastElementChild
    const toast = new bootstrap.Toast(toastEl)
    toast.show()
  }
}
